$(function () {
  $('.product-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    speed: 300,
    asNavFor: '.slider-nav',
    lazyload: 'progressive',
  });
  $('.slider-nav').slick({
    asNavFor: '.product-images',
    infinite: true,
    centerMode: false,
    arrows: false,
    focusOnSelect: true,
    dots: true,
    slidesToShow: 1,
    lazyload: 'progressive',
    customPaging: function (slick, index) {
      var targetImage = slick.$slides.eq(index).find("img").attr("src");
      if (!targetImage) {
        targetImage = slick.$slides.eq(index).find("img").attr("data-lazy");
      }
      var targetLabel = slick.$slides.eq(index).find("span").text();
      return '<img class="lazyload" src=" ' + targetImage + ' "/><span>' + targetLabel + '</span>';
    },
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: false,
        }
      }
    ]
  });
  /* variant change */
  $("#cart_form input").on('change', function () {
    var selectedOption = $(':radio:checked').map(function () {
      return $(this).val();
    }).get();
    const optionName = selectedOption.join(" / ");
    const variantId = $("select[name='id'] option").filter(function (index) {
      return $(this).text() === optionName;
    }).val();
    const isSoldOut = $("select[name='id'] option").filter(function (index) {
      return $(this).text() === optionName;
    }).attr('disabled');
    if (isSoldOut === 'disabled') {
      $(".cart_btn").addClass('soldout');
      $(".cart_btn").text('SOLD OUT');
    } else {
      $(".cart_btn").removeClass('soldout');
      $(".cart_btn").text('');
      $(".cart_btn").append('<a class="cart_btn--text">カートに入れる</a>');
    }
    $("select[name='id']").val(variantId).change();
  });
  /* cart modal */
  $(window).scroll(function () {
    $(".product-single__meta").each(function () {
      var top_height = $(this).height();
      var scroll = $(window).scrollTop();
      if (scroll > top_height + $(this).offset().top) {
        $(".product_bottom").addClass("on");
      } else {
        //$(".product_bottom").removeClass("on");
      }
    });
    if ($(window).scrollTop() + $(window).height() > $(".product-info").offset().top + $(".product-info").height()) {
      //$(".product_bottom").removeClass("on");
    }
  });
  $(".product_bottom .cart_btn").on("click", function () {
    $("body").css({ top: 0, position: "fixed", width: "100%" });
    $(".product-single__meta form").appendTo("#cart_modal .modal_inner").hide().fadeIn(300, function () {
      $("#cart_modal").addClass("open");
    });
  });
  $(".modal_inner--close").on('click', function () {
    closeModal()
  })
  $(document).on("click", "#cart_modal.open", function (event) {
    if (!$(event.target).closest(".modal_inner").length) {
      closeModal()
    }
  });
  function closeModal() {
    $("body").removeAttr("style");
    $("#cart_modal").removeClass("open").delay(400).queue(function (next) {
      $("#cart_modal form").appendTo(".product-single__meta");
      next();
    });
  }
})